import { OrderedAsyncEnumerable } from "../OrderedAsyncEnumerable.js";
export const orderByAsync = (source, keySelector, comparer) => {
    return OrderedAsyncEnumerable.generateAsync(source, keySelector, true, comparer);
};
